// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gLID","name":"styles_name__2Aibm","phone":"styles_phone__2n-oG"};